import { Injectable } from '@angular/core';
import { ILocalStorageItem, ILocalStorageItem2 } from '../shared/interfaces/istorage.interface';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {
  private storageSub = new BehaviorSubject<ILocalStorageItem | ILocalStorageItem2 | null>(null);
  private courseInfoSubject = new BehaviorSubject<any>(this.getCourseInfoFromLocalStorage());
  private modulesInfoSubject = new BehaviorSubject<any>(this.getModulesInfoFromLocalStorage());
  private lessonsInfoSubject = new BehaviorSubject<any>(this.getLessonsInfoFromLocalStorage());
  courseInfo$ = this.courseInfoSubject.asObservable();
  modulesInfo$ = this.modulesInfoSubject.asObservable();
  lessonsInfo$ = this.lessonsInfoSubject.asObservable();
  constructor() { }

  watchStorage(): Observable<ILocalStorageItem | ILocalStorageItem2 | null> {
    return this.storageSub.asObservable();
  }

  getItem(itemName:ILocalStorageItem){
    return localStorage.getItem(itemName)
  }

  setItem(itemName:ILocalStorageItem, itemValue:string) {
    localStorage.setItem(itemName, itemValue);
    this.storageSub.next(itemName);
  }


  getCurrentUserAsJson(){
    const item:ILocalStorageItem = 'current_user_edutegia';
    return JSON.parse(localStorage.getItem(item) || '{}');
  }

  getCurrentUserProfileAsJson(){
    const item:ILocalStorageItem = 'profile_current_user';
    return JSON.parse(localStorage.getItem(item) || '{}');
  }

  getLogoutToken(){
    const item:ILocalStorageItem2 = 'logoutToken';
    return localStorage.getItem(item);
  }

  getCsrfToken(){
    const item:ILocalStorageItem2 = 'csrfToken';
    return localStorage.getItem(item);
  }

  getJwtToken(){
    const item:ILocalStorageItem2 = 'jwtToken';
    return localStorage.getItem(item);
  }

  getCourseInfoFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('courseInfo') || '{}');
  }

  setCourseInfo(courseInfo: any) {
    localStorage.setItem('courseInfo', JSON.stringify(courseInfo));
    this.courseInfoSubject.next(courseInfo);
  }
  getModulesInfoFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('modules') || '{}');
  }

  setModulesInfo(modules: any) {
    localStorage.setItem('modules', JSON.stringify(modules));
    this.modulesInfoSubject.next(modules);
  }
  getLessonsInfoFromLocalStorage(): any {
    return JSON.parse(localStorage.getItem('lessons') || '{}');
  }

  setLessonsInfo(lessons: any) {
    localStorage.setItem('lessons', JSON.stringify(lessons));
    this.lessonsInfoSubject.next(lessons);
  }


}
